import { render, staticRenderFns } from "./TripAssignments.vue?vue&type=template&id=e16e143a&scoped=true&"
import script from "./TripAssignments.vue?vue&type=script&lang=js&"
export * from "./TripAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16e143a",
  null
  
)

export default component.exports